declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const META_PIXEL_ID = '27104340725842915'

let isInitialized = false

export function initMetaPixel() {
  if (isInitialized || typeof window === 'undefined') return

  // Meta Pixel base code
  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v

  const s = b.getElementsByTagName(e)[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  }

  // Initialize pixel and fire PageView
  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  isInitialized = true
}

export function trackMetaEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  if (typeof window !== 'undefined' && window.fbq) {
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  }
}

/**
 * Appends fbclid from current URL to destination URL for cross-domain tracking.
 */
export function getCheckoutUrlWithFbclid(baseUrl: string): string {
  if (typeof window === 'undefined') return baseUrl

  const urlParams = new URLSearchParams(window.location.search)
  const fbclid = urlParams.get('fbclid')

  if (fbclid) {
    const separator = baseUrl.includes('?') ? '&' : '?'
    return `${baseUrl}${separator}fbclid=${encodeURIComponent(fbclid)}`
  }

  return baseUrl
}
